import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./api-key-detail-view.scss";
import sharedStyle from "components/api-keys-settings/general-setting-view.scss";
import { ApiKey, getApiKeyScopeLocalizationKey, isApiKeyExpired } from "domain/apiKeys";
import { createDateLabel, formatTimestamp } from "utils/format";

import testIds from "testIds.json";

export const ApiKeyDetailView = (props: { activeApiKey: ApiKey }): JSX.Element => {
    const { t } = useTranslation();
    const scopeText = t(getApiKeyScopeLocalizationKey(props.activeApiKey.scope));

    return (
        <div className={style.dialogBox}>
            <div className={style.apiKeyProfile}>
                <div className={style.label}>{t("Common.nameWithColon")}</div>
                <div data-testid={testIds.workArea.support.apiKeys.viewApiKeyDialog.nameLabel}>
                    {props.activeApiKey.name}
                </div>
                <div className={style.label}>{t("ApiKeys.scopeWithColon")}</div>
                <div data-testid={testIds.workArea.support.apiKeys.viewApiKeyDialog.scopeLabel}>{scopeText}</div>
                <div className={style.label}>{t("ApiKeysProfile.creationDate")}</div>
                <div data-testid={testIds.workArea.support.apiKeys.viewApiKeyDialog.creationDateLabel}>
                    {formatTimestamp(props.activeApiKey.created)}
                </div>
                {props.activeApiKey.expiration && (
                    <>
                        <div className={style.label}>{t("Common.expirationDateWithColon")}</div>
                        <div
                            className={classNames({
                                [sharedStyle.expiredDate]: isApiKeyExpired(props.activeApiKey.expiration),
                            })}
                            data-testid={testIds.workArea.support.apiKeys.viewApiKeyDialog.expirationDateLabel}
                        >
                            {createDateLabel(props.activeApiKey.expiration)}
                        </div>
                    </>
                )}
                {props.activeApiKey.description && (
                    <>
                        <div className={style.label}>{t("ApiKeys.descriptionWithColon")}</div>
                        <div data-testid={testIds.workArea.support.apiKeys.viewApiKeyDialog.descriptionLabel}>
                            {props.activeApiKey.description}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
